"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import { topicsData } from "../data";
import {
  getFilteredSubpages,
  highlightText,
} from "@/app/helpers/getSearchResults";
import SearchIcon from "@/assets/svgs/SearchIcon";

export const TopSectionFAQ = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const filteredSubpages = getFilteredSubpages(topicsData, debouncedSearchTerm);

  return (
    <section className="Hilfezentrum">
      <div className="FAQ-container">
        <div className="FAQ-Top-Animation"></div>
        <div className="FAQ-title-wrapper">
          <h1>
            Suche in unserem <br className="mobile" /> Hilfezentrum
          </h1>
          <div className="search-input-wrapper">
            <input
              type="text"
              placeholder="Suche..."
              className="search-input transition"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <SearchIcon className="search-icon" />

            {debouncedSearchTerm && (
              <div className="FAQ-results">
                {filteredSubpages.length > 0 ? (
                  filteredSubpages.map((faq) => (
                    <Link
                      key={`${faq.id}-${faq.link}-${faq.subpageLink}`} // Ensure a unique key
                      href={`/faq${faq.link}${faq.subpageLink}`}
                    >
                      <div key={faq.id} className="FAQ-item transition">
                        <h2>{highlightText(faq.title, searchTerm)}</h2>
                        <p className="Search-result-text">
                          FAQ {" > "}
                          {faq.link.replace(/^\/+/, "")} {" > "}
                          {faq.subpageLink.replace(/^\/+/, "")}
                        </p>
                      </div>
                    </Link>
                  ))
                ) : (
                  <div className="FAQ-item">
                    <p>Keine Ergebnisse gefunden.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
